import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '../services/modal.service';
import { LucideAngularModule, X, Rocket } from 'lucide-angular';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-coming-soon-modal',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, TranslateModule],
  template: `
    <div *ngIf="modalService.isComingSoonOpen()" class="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div class="absolute inset-0 bg-dark-100/80 backdrop-blur-sm" (click)="modalService.closeComingSoon()"></div>
      <div class="relative bg-dark-200 border border-white/[0.08] rounded-3xl p-8 max-w-sm w-full text-center shadow-2xl transform transition-all" data-aos="zoom-in" data-aos-duration="300">
        <button (click)="modalService.closeComingSoon()" class="absolute top-4 right-4 text-gray-500 hover:text-white transition-colors">
          <lucide-icon [img]="X" class="w-5 h-5"></lucide-icon>
        </button>
        
        <div class="w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center mx-auto mb-6">
          <lucide-icon [img]="Rocket" class="w-8 h-8 text-primary"></lucide-icon>
        </div>
        
        <h3 class="text-2xl font-black text-white mb-2">{{ 'COMING_SOON_MODAL.TITLE' | translate }}</h3>
        <p class="text-sm text-gray-400 mb-6">
          {{ 'COMING_SOON_MODAL.DESC' | translate }}
        </p>
        
        <button (click)="modalService.closeComingSoon()" class="w-full py-3 rounded-xl bg-white/[0.04] hover:bg-white/[0.08] border border-white/[0.08] text-white text-sm font-bold transition-all">
          {{ 'COMING_SOON_MODAL.BTN' | translate }}
        </button>
      </div>
    </div>
  `
})
export class ComingSoonModalComponent {
  modalService = inject(ModalService);
  readonly X = X;
  readonly Rocket = Rocket;
}
